export default "__VITE_ASSET__0m_AX82n__"